export const isInteger = (arg: any): arg is number => Number.isInteger(arg);
